import {
  button_default
} from "./chunk-CBJJ6H3K.js";

// src/blocks/button/index.ts
var button_default2 = button_default;

export {
  button_default2 as button_default
};
